<template lang="pug">
  .subscription
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="handleBack") mdi-arrow-left
        div.title.font-weight-bold {{ $t('subscription') }}

      v-layout.my-6(v-if="!$store.state.subscriptions.isReady")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        div.my-6
          .s1 {{ $t('my_plans') }}
          .c1.basic600--text
            | {{ $t('products_plans_subscribed') }}
            //- span.textColorAccent--text(@click="sendRequest")  Click here
            //- |  to change your company subscription.

          .empty.mt-4(v-if="noSubscription")

            div.mx-auto.text-center
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption.text-center {{ $t('no_subscription_found') }}
          
          template(v-else)
            .clinic-cms
              v-card.mt-4(v-if="multiBranchTrial.value || multiBranchSubscription.value" outlined flat)
                .content.pa-4
                  .trial(v-if="multiBranchTrial.value")
                    .p2 Multibranch
                    div.d-flex
                      .s2.text-uppercase {{ $t('trial') }}
                    .c1.primary400--text
                      span(v-if="multiBranchTrial.data.expired") {{ $t('trial_ended_at') }} {{ multiBranchTrial.data.end_date | humanizeDate }}
                      span(v-else) {{ $t('trial_ends') }}: {{ multiBranchTrial.data.end_date | humanizeDate }}

                  .subscribed(v-else-if="multiBranchSubscription.value")
                    .p2 Multibranch
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(multiBranchSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ multiBranchSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ multiBranchSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ multiBranchSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="multiBranchSubscription.data.contract.code.includes('_YY') || multiBranchSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ multiBranchSubscription.data.contract_end_date | humanizeDate }}
                  
                  .d-flex.mt-4
                    v-spacer
                    //v-btn.button-AA-tiny.white--text(v-if="multiBranchTrial.value" color="info500" small depressed @click="showSubscribeCmsModal = true") {{ $t('subscribe_now') }}
                    v-btn.button-Aa-small.info500--text.px-0(v-if="multiBranchSubscription.value" text color="transparent" small depressed :loading="isLoadingExpired" @click="multiBranchExpired ? checkExpired('multibranch') : showEditSubscriptionMultibranchModal = true") {{ multiBranchExpired ?  $t('renew_subscription') : $t('edit_subscription') }}

    .modals
      edit-subscription-multibranch-modal(v-if="showEditSubscriptionMultibranchModal" :open.sync="showEditSubscriptionMultibranchModal" :company="company" @subscribed="$store.commit('subscriptions/update')" @setgene="setGene")

</template>

<script>
import { mapActions, mapState } from 'vuex'
import EditSubscriptionMultibranchModal from '@/components/hq/dialogs/EditSubscriptionMultibranchModal.vue'

export default {
  name: 'HqSubscriptionSettings',
  components: {
    EditSubscriptionMultibranchModal
  },
  props: ['company', 'menu'],
  data: () =>  ({
    showYezzaIntroModal: false,
    showSubscribeMultibranchModal: false,
    showEditSubscriptionMultibranchModal: false,
    isLoadingExpired: false,
    contract: null,
    isLoading: false,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', [
      'noSubscription',
      'multiBranchSubscription',
      'multiBranchTrial',
    ]),
    multiBranchExpired () {
      return !!(this.multiBranchSubscription.value && this.multiBranchSubscription.data.expired);
    },
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getContractDisplayName (contract) {
      let display = ''
      if (contract.includes('YZ_')) {
        if (contract.includes('_Y')) {
          display += ' (YEARLY)'
        } else if (contract.includes('_M')) {
          display += ' (MONTHLY)'
        }
      }
      if (contract.includes('_TRIAL')) {
        display += ' (TRIAL)'
      }
      return display
    },
    closeDialog () {
      this.openSuccessDialog = false
      this.unsubscribeModal = false
      this.unsubscribePlan = null
      this.message = null
      window.location.reload()
    },
    checkCode (code) {
      if (code === 'YZ_LANDING_PAGE') {
        return true
      } else if (code === 'YZ_FOLLOW_UP') {
        return true
      } else if (code === 'YZ_PRODUCT_BUNDLE') {
        return true
      } else if (code === 'YZ_RESELLER') {
        return true
      }
      return false
    },
    setGene () {
      this.$axios.get(`/companies/${this.company.id}/genes`)
        .then((response) => {
          this.$store.commit('subscriptions/setGenes', response.data)
        })
    },
    checkExpired (subscription) {
      this.isLoadingExpired = true
      this.$axios.get(`/subscription/bills/?page=1&page_size=12&company=${this.company.id}&ordering=-created&paid=false`)
        .then((response) => {
          let bills = response.data.results
          let hasPendingBills = response.data.count > 0
          this.$store.commit('subscriptions/setHasPendingBills', hasPendingBills)
          if (hasPendingBills) {
            this.$router.push(`/admin/billing/bills/${bills[0].id}`)
          } else {
            if (subscription === 'multibranch') {
              this.showSubscribeMultibranchModal = true
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingExpired = false
        })
    },
    handleBack () {
      this.$router.push('/admin/hq/settings')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "subscription": "Subscription",
    "my_plans": "My plans",
    "products_plans_subscribed": "Products and plans you are subscribed to.",
    "click_here": "Click here",
    "to_change_company_subscription": "to change your company subscription.",
    "no_subscription_found": "No subscription found",
    "trial_ended_at": "Trial ended at",
    "trial_ends": "Trial ends",
    "next_billing_date": "Next billing date",
    "contract_ends": "Contract ends",
    "sales_team": "Sales Team",
    "unlimited": "Unlimited",
    "whatsapp_forms": "WhatsApp Forms",
    "sales_page": "Sales Page",
    "trial": "TRIAL",
    "books": "Books",
    "reminder_scheduling": "Reminder Scheduling",
    "more_products": "More products",
    "more_products_desc": "Check out other products that we offer.",
    "on_trial": "On Trial",
    "subscribed": "Subscribed",
    "tell_me_more": "Tell me more",
    "setup_online_store_manage": "Setup an online store and manage orders all in one place",
    "subscribe": "Subscribe",
    "keep_track_income_expenses": "Keep track of your income and expenses with Books",
    "unsubscribe": "Unsubscribe",
    "monthly": "Monthly",
    "bundle_offer": "Bundle offer",
    "agent_commission": "Agent commission",
    "custom_your_landing_page": "Custom your landing page with headline, copywriting & images",
    "check_out_addons": "Check out add-ons that we offer.",
    "increase_your_sales_through": "Increase your sales through an automated follow-up routine",
    "included": "Included",
    "active_until": "Active until",
    "increase_average_sales_bundle": "Increase average sales per order through bundle offers to your customers.",
    "increase_sales_multi_level": "Increase your sales using multi-level agent commissions system.",
    "yezza_price_per_month": "from {price}/month",
    "books_price_per_month": "from {price}/month",
    "page_price_per_month": "from {price}/month",
    "follow_up_price_per_month": "from {price}/month",
    "bundle_price_per_month": "from {price}/month",
    "agent_price_per_month": "from {price}/month",
    "unsubscribe_confirmation": "Are you sure you want to unsubscribe",
    "connect_subscription_description": "Manage workflow and 1:1 engagements on WhatsApp.",
    "clinic": "Clinic",
    "review_subscription_description": "Manage your review from your customer",
    "review_subscription_setup": "Setup your review management system in 2 minutes"
  },
  "id": {
    "subscription": "Langganan",
    "my_plans": "Rencanaku",
    "products_plans_subscribed": "Produk dan paket langganan kamu.",
    "click_here": "Klik disini",
    "to_change_company_subscription": "untuk mengubah langganan perusahaan kamu.",
    "no_subscription_found": "Tidak ada langganan yang ditemukan",
    "trial_ended_at": "Uji coba berakhir pada",
    "trial_ends": "Percobaan berakhir",
    "next_billing_date": "Tanggal tagihan berikutnya",
    "contract_ends": "Kontrak berakhir",
    "sales_team": "Tim Penjualan",
    "unlimited": "Tidak terbatas",
    "whatsapp_forms": "form WhatsApp",
    "sales_page": "Halaman Penjualan",
    "trial": "UJI COBA",
    "books": "Buku",
    "reminder_scheduling": "Penjadwalan Pengingat",
    "more_products": "Produk lainnya",
    "more_products_desc": "Lihat produk lain yang kami tawarkan.",
    "on_trial": "Sedang Percobaan",
    "subscribed": "Berlangganan",
    "tell_me_more": "Ceritakan lebih banyak lagi",
    "setup_online_store_manage": "Siapkan toko online dan kelola semua pesanan dalam satu tempat",
    "subscribe": "Langganan",
    "keep_track_income_expenses": "Pantau pemasukan dan pengeluaran kamu dengan Book",
    "unsubscribe": "Berhenti berlangganan",
    "monthly": "Bulanan",
    "bundle_offer": "Penawaran paket",
    "agent_commission": "Komisi agen",
    "custom_your_landing_page": "Kustomisasi halaman arahan kamu dengan judul, copywriting & gambar",
    "check_out_addons": "Lihat add-on yang kami tawarkan.",
    "increase_your_sales_through": "Tingkatkan penjualan kamu melalui rutinitas tindak lanjut otomatis",
    "included": "Termasuk",
    "active_until": "Aktif sampai",
    "increase_average_sales_bundle": "Tingkatkan rata-rata penjualan per pesanan melalui penawaran Bundle kepada pelanggan kamu.",
    "increase_sales_multi_level": "Tingkatkan penjualan kamu menggunakan sistem komisi agen multi-level.",
    "yezza_price_per_month": "dari {price}/bulan",
    "books_price_per_month": "dari {price}/bulan",
    "page_price_per_month": "dari {price}/bulan",
    "follow_up_price_per_month": "dari {price}/bulan",
    "bundle_price_per_month": "dari {price}/bulan",
    "agent_price_per_month": "dari {price}/bulan",
    "unsubscribe_confirmation": "Apakah kamu yakin ingin berhenti berlangganan?",
    "connect_subscription_description": "Kelola alur kerja dan interaksi 1:1 di WhatsApp.",
    "clinic": "Clinic",
    "review_subscription_description": "Manage your review from your customer",
    "review_subscription_setup": "Setup your review management system in 2 minutes"
  }
}

</i18n>
